export const enableHMRForChain = (chain: any) => {
    if (module.hot) {
        module.hot.accept();
        const originalChain = chain.slice();
        module.hot.dispose(data => {
            chain.length = 0;
            originalChain.forEach((o: any) => chain.push(o));
        });
    }
};

export const propertyTruthy = (property: any) => {
    let truthy = false;
    switch (property?.toString().toLowerCase()) {
        case "yes":
        case "true":
        case "1":
        case 1:
        case true:
            truthy = true;
            break;
        default:
            truthy = false;
    }
    return truthy;
};

export const guidToString = (guid: string) => {
    return guid.replace(/-/g, "");
};

export const moveFocus = (key: string, childItems: HTMLElement[], onFirstChild: boolean) => {
    const focusElement = document.activeElement as HTMLElement;

    let newIndex = 0;
    let currentIndex = childItems.indexOf(focusElement!);
    if (onFirstChild) {
        currentIndex = childItems.indexOf(focusElement!.parentElement!);
    }

    switch (key) {
        case "arrowdown":
            newIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % childItems.length;
            break;
        case "arrowup":
            newIndex =
                currentIndex === -1
                    ? childItems.length - 1
                    : (currentIndex + childItems.length - 1) % childItems.length;
            break;
        default: {
            const index = childItems.findIndex(option => option.innerText.toLowerCase().startsWith(key));
            newIndex = index === -1 ? 0 : index;
        }
    }

    let child = childItems[newIndex];
    if (onFirstChild) {
        child = (child as HTMLElement).firstChild as HTMLElement;
    }
    child?.focus();
};

// Utility function to format a date to YYYY-MM-DD
export const formatDateToYYYYMMDD = (dateInput: string | Date): string => {
    const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
    return date.toISOString().split("T")[0];
};
